import Vue from 'vue';
import Router from 'vue-router';
// import App from './App.vue';

function lazyLoading(name) {
    return function () {
        return import(`./views/${name}.vue`);
    };
}

const DefaultIndex = {
    render(h) {
        return h('router-view', {
            key: this.$route.name || this.$route.path,
        });
    },
};

Vue.use(Router);

export default new Router({
    base: '/',
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: lazyLoading('Home'),
            meta: {
                title: 'chrisbella',
            },
        },
        {
            path: '/presale',
            component: DefaultIndex,
            redirect: {
                name: 'presaleList',
            },
            children: [
                {
                    name: 'presaleList',
                    path: '/presale-list/:series_id',
                    component: lazyLoading('presale/PresaleList'),
                    meta: {
                        title: '预售列表',
                    },
                },
            ],
        },
        {
            path: '/production',
            component: DefaultIndex,
            redirect: {
                name: 'presaleProduction',
            },
            children: [
                {
                    name: 'presaleProduction',
                    path: 'presale-production/:series_id',
                    component: lazyLoading('presaleProduction/presaleProduction'),
                    meta: {
                        title: '在产预售',
                    },
                },
            ],
        },
        {
            path: '/spot',
            component: DefaultIndex,
            redirect: {
                name: 'spotGoods',
            },
            children: [
                {
                    name: 'spotGoods',
                    path: 'spot-goods/:series_id',
                    component: lazyLoading('spotGoods/SpotGoods'),
                    meta: {
                        title: '现货',
                    },
                },
            ],
        },
        {
            path: '/product',
            component: DefaultIndex,
            redirect: {
                name: 'productDetail',
            },
            children: [
                {
                    name: 'productDetail',
                    path: 'product-detail:good_id',
                    component: lazyLoading('product/productDetail'),
                    meta: {
                        title: '预售列表',
                    },
                },
            ],
        },
        {
            path: '/wish-list',
            component: DefaultIndex,
            redirect: {
                name: 'wishProduct',
            },
            children: [
                {
                    name: 'wishProduct',
                    path: 'wish-product',
                    component: lazyLoading('wishList/WishList'),
                    meta: {
                        title: '心愿单',
                    },
                },
            ],
        },
        {
            path: '/cart',
            component: DefaultIndex,
            redirect: {
                name: 'shoppingCart',
            },
            children: [
                {
                    name: 'shoppingCart',
                    path: 'shopping-cart',
                    component: lazyLoading('shoppingCart/ShoppingCart'),
                    meta: {
                        title: '购物车',
                    },
                },
                {
                    name: 'Balance',
                    path: 'balance',
                    component: lazyLoading('shoppingCart/Balance'),
                    meta: {
                        title: '结算',
                    },
                },
                {
                    name: 'PaySuccess',
                    path: 'pay-success',
                    component: lazyLoading('shoppingCart/PaySuccess'),
                    meta: {
                        title: '结算成功',
                    },
                },
            ],
        },
        {
            path: '/person',
            component: lazyLoading('personCenter/OrderIndex'),
            redirect: {
                name: 'PersonInfo',
            },
            children: [
                {
                    name: 'PersonInfo',
                    path: 'person-info',
                    component: lazyLoading('personCenter/PersonInfo'),
                    meta: {
                        title: '个人信息',
                    },
                },
                {
                    name: 'PersonOrders',
                    path: 'person-orders',
                    component: lazyLoading('personCenter/Orders'),
                    meta: {
                        title: '订单',
                    },
                },
                {
                    name: 'PersonBack',
                    path: 'person-back',
                    component: lazyLoading('personCenter/Feedback'),
                    meta: {
                        title: '反馈',
                    },
                },
            ],
        },
        {
            path: '/detail',
            component: DefaultIndex,
            redirect: {
                name: 'OrderDetail',
            },
            children: [
                {
                    name: 'OrderDetail',
                    path: 'order-detail/:order_id',
                    component: lazyLoading('personCenter/OrderDetail'),
                    meta: {
                        title: '订单详情',
                    },
                },
            ],
        },
        {
            path: '/privacy',
            name: 'Privacy',
            meta: {
                title: '隐私政策',
            },
            component: lazyLoading('personCenter/Privacy'),
        },
        {
            path: '/search',
            component: DefaultIndex,
            redirect: {
                name: 'SearchItems',
            },
            children: [
                {
                    name: 'SearchItems',
                    path: 'search-items',
                    component: lazyLoading('product/SearchItems'),
                    meta: {
                        title: '搜索结果',
                    },
                },
            ],
        },
        {
            path: '/login',
            component: DefaultIndex,
            redirect: {
                name: 'Login',
            },
            children: [
                {
                    name: 'Login',
                    path: '/',
                    component: lazyLoading('login/Login'),
                    meta: {
                        title: '用户登录',
                    },
                },
            ],
        },
        {
            path: '*',
            redirect: '/',
        },
    ],
});
